import axios from 'axios'
// import store from 'src/store'
import {showErrorMsg} from 'src/utils/dialog'
import router from 'src/router'
import {API_BASE_URL} from 'src/config/pathConfig'

// create an axios instance
const service = axios.create({
  // baseURL: 'http://localhost:8082/hgnc/api/',
  baseURL: API_BASE_URL,
  timeout: 9000 // request timeout
})

service.defaults.headers.post['Content-Type'] = 'application/json'
service.defaults.headers.head['Access-Control-Allow-Origin'] = '*'
service.defaults.headers.head['Access-Control-Allow-Credentials'] = 'true'
service.defaults.headers.head['Access-Control-Allow-Methods'] = 'GET, POST, OPTIONS'
service.defaults.headers.head['Access-Control-Allow-Headers'] = 'DNT,X-CustomHeader,Keep-Alive,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type'

// request interceptor
service.interceptors.request.use(
  config => {
    return config
  },
  err => {
    return Promise.reject(err)
  })

// respone interceptor
service.interceptors.response.use(
  response => {
    let errorMessage
    if (response.status === 200) {
      if (response.data && response.data !== '') {
        // console.log('请求结果：')
        // console.log(response.data)
        if (response.data.code === '004') {
          showErrorMsg('token Invalid')
          router.replace({name: '/'})
        } else if (response.data.code !== '000') {
          showErrorMsg('data code[' + response.data.code + '] errorMsg[' + response.data.msg + ']')
        }
      } else {
        showErrorMsg('data is null')
      }
      if (errorMessage) {
        return Promise.reject(errorMessage)
      }
      return Promise.resolve(response.data)
    } else {
      errorMessage = 'error'
      return Promise.reject(errorMessage)
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          router.replace({
            path: '/',
            query: {redirect: router.currentRoute.fullPath}
          })
      }
      return Promise.reject(error.response.data)
    } else {
      return Promise.reject(error)
    }
  })

export default service



// WEBPACK FOOTER //
// ./src/http/request.js